<template>
  <el-dialog
    title="上传合约文件"
    :visible.sync="showDialog"
    :before-close="cacel"
    top="25vh"
    class="add-rust-contract-dialog common-dialog"
  >
    <el-alert
      class="alert-info"
      title="提示"
      type="info"
      description="请上传Rust合约的字节码文件"
      show-icon
      :closable="false"
    >
    </el-alert>
    <el-form ref="addRustContract" :model="model" :rules="rules" :label-width="`${adaptationVars.formLabelWidth}px`">
      <el-form-item label="合约文件" prop="fileRaw">
        <upload-files
          ref="contractFile"
          file-ext=".wasm|"
          @uploadSuccess="onUploadSuccess"
          @uploadFailed="onUploadFailed"
          @uploadRemove="onUploadRemove"
        ></upload-files>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'AddRustContract',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
      model: {
        fileRaw: ''
      },
      rules: {
        fileRaw: [{ required: true, message: '请按要求上传合约文件', trigger: 'blur' }]
      },
      showDialog: false,
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    cacel() {
      this.showDialog = false
      this.$refs.contractFile.clear()
    },
    makeSure() {
      let self = this
      this.$refs['addRustContract'].validate(valid => {
        if (valid) {
          console.log('submit!')
          let formData = new FormData()
          formData.append('rust_contract', self.model.fileRaw.raw)
          self.$apis.contractdetector.uploadRustContract(formData).then(res => {
            if (res && res.data && res.code === 1) {
              self.showDialog = false

              self.$emit('addSuccess')
              self.$message({
                type: 'success',
                message: '上传合约成功!'
              })
            } else {
              if (!res.error) {
                self.$message({
                  type: 'error',
                  message: '上传合约失败!'
                })
              } else {
                const h = self.$createElement
                self.$message({
                  type: 'error',
                  message: h('p', null, [
                    h('div', { style: 'color: red' }, '上传合约失败!'),
                    h('div', { style: 'color: teal' }, res.error)
                  ])
                })
              }
            }
            // console.log(res)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onUploadSuccess() {
      this.model.fileRaw = this.$refs.contractFile.getFileRaw()
      this.$refs.addRustContract.clearValidate()
    },
    onUploadFailed() {
      this.model.fileRaw = ''
    },
    onUploadRemove() {
      this.model.fileRaw = ''
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.add-rust-contract-dialog {


  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }
  .alert-info {
    margin-bottom: var(--base-size-20);
    width: 90%;
    margin-left: 5%;
  }
  
  .el-form {
    margin-right: var(--base-size-48);
  }
}
</style>
